<template>
    <modal
        v-model="proxyValue"
    >
        <template #header>
            <div class="mx-auto bg-red-300 w-24 h-24 rounded-full flex items-center justify-center">
                <icon type="exclamation-circle" class="w-12 h-12 text-gray-100" />
            </div>
        </template>

        <slot />

        <template #footer="{ close }">
            <button
                @click.prevent="close"
                class="btn btn-red"
            >
                Close
            </button>
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/shared/Modal'
import Icon from '@/components/shared/Icon'
export default {
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue'],
    computed: {
        proxyValue: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    components: {
        Modal,
        Icon,
    }
}
</script>
